import { I18n } from 'react-redux-i18n';

function outboundVolumeStatus(status) {
  if (status || status === 0) {
    switch (status) {
      case 1:
        return I18n.t('BEE2077' /* Em aberto */);
      case 2:
        return I18n.t('BEE1949' /* Pendente Docas */);
      case 3:
        return I18n.t('BEE2278' /* Pendente de Consolidação */);
      case 4:
        return I18n.t('BEE1833' /* Finalizado */);
      default:
        return status;
    }
  } else if (!status) {
    return [
      { value: 1, label: I18n.t('BEE2077' /* Em aberto */) },
      { value: 2, label: I18n.t('BEE1949' /* Pendente Docas */) },
      { value: 3, label: I18n.t('BEE2278' /* Pendente de Consolidação */) },
      { value: 4, label: I18n.t('BEE1833' /* Finalizado */) },
    ];
  }
}

export default {
  outboundVolumeStatus,
};
